const SECTION_SELECTOR = '#MainContent';

/**
 * Product switcher chips (`blocks/_product-switcher.liquid`): swap the main
 * product section in place via fetch + DOMParser instead of a full page
 * navigation, carry the chip's color scheme onto the document, and keep the
 * URL in sync via history.pushState.
 *
 *   x-data="productSwitcher"
 *   @click.prevent.stop="switchProduct($el)"
 *
 * The chip carries `data-color-primary` / `data-color-secondary` for the scheme.
 */
export default () => ({
  switchProduct(el) {
    const url = el.href;
    const container = el.closest(SECTION_SELECTOR);
    if (!container) return;

    const { colorPrimary, colorSecondary } = el.dataset;
    if (colorPrimary) {
      document.documentElement.style.setProperty('--color-product-primary', colorPrimary);
    }
    if (colorSecondary) {
      document.documentElement.style.setProperty('--color-product-secondary', colorSecondary);
    }

    container.classList.add('js-loading');
    fetch(url)
      .then((res) => res.text())
      .then((html) => {
        const dom = new DOMParser().parseFromString(html, 'text/html');
        const section = dom.querySelector(SECTION_SELECTOR);
        if (section) container.innerHTML = section.innerHTML;
        container.classList.remove('js-loading');
        history.pushState({}, '', url);
      });
  },
});
